module.exports = __webpack_public_path__ + "static/media/8-3.f3a2e424.mp3";